import * as React from 'react';
import { SVGProps } from 'react';

const SvgStatusFailed = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} viewBox="0 0 80 80" fill="none" role="img" {...props}>
    <circle cx={40} cy={40} r={40} fill="#FFF3F5" />
    <rect x={8} y={8} width={64} height={64} rx={32} fill="#fff" />
    <path
      d="M71 40c0 17.12-13.88 31-31 31C22.88 71 9 57.12 9 40 9 22.88 22.88 9 40 9c17.12 0 31 13.88 31 31ZM31.496 27.96a2.5 2.5 0 0 0-3.536 3.536l8.839 8.838-8.839 8.84a2.5 2.5 0 1 0 3.536 3.535l8.838-8.839 8.84 8.839a2.5 2.5 0 1 0 3.535-3.536l-8.839-8.839 8.839-8.838a2.5 2.5 0 0 0-3.536-3.536L40.334 36.8l-8.838-8.839Z"
      fill="#F55B7A"
      stroke="#fff"
      strokeWidth={2}
    />
  </svg>
);

export default SvgStatusFailed;
